module.exports = __webpack_public_path__ + "static/media/empty_cart_icon.61c7cd9f.png";